import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { returnsApi, type ReturnRequest } from '../../api/returns';

export function RMADashboardPage() {
  const [returns, setReturns] = useState<ReturnRequest[]>([]);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    void returnsApi.listReturns().then(setReturns);
  }, []);

  async function generateRMA(ret: ReturnRequest) {
    const rma = await returnsApi.createRMA(ret.id);
    setMsg(`RMA ${rma.rma_number} — barcode ${rma.barcode ?? 'n/a'}`);
  }

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/returns" className="text-sm text-slate-600 hover:underline">← Returns hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">RMA dashboard</h1>
      {msg && <p className="mt-2 text-sm text-green-700">{msg}</p>}
      <ul className="mt-4 space-y-2">
        {returns.filter((r) => r.status === 'approved').map((r) => (
          <li key={r.id}>
            <button type="button" onClick={() => void generateRMA(r)}
              className="rounded border px-3 py-2 text-sm hover:bg-slate-50">
              Generate RMA for {r.return_number}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
